export default function AdminStats({ items }) {
    return (
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3" data-testid="admin-stats">
            {items.map((s, i) => (
                <div
                    key={s.label}
                    className={`adm-panel adm-stat adm-fade-in p-4 ${s.accent ? "!border-amber-400/60" : ""}`}
                    style={{ animationDelay: `${i * 60}ms` }}
                    data-testid={`admin-stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                    <div className="flex items-center justify-between label-kicker mb-2">
                        <span>{s.label}</span>
                        <span className="w-7 h-7 rounded-md grid place-items-center bg-[hsl(var(--primary)/0.14)] text-[hsl(var(--primary))]">
                            <s.icon className="w-3.5 h-3.5" />
                        </span>
                    </div>
                    <div className={`font-display font-black text-3xl tracking-tight ${s.accent ? "text-amber-500" : "adm-heading"}`}>
                        {s.val ?? "—"}
                    </div>
                    {s.sub && <div className="text-[10px] font-mono text-slate-500 mt-0.5">{s.sub}</div>}
                </div>
            ))}
        </div>
    );
}
